import React, { useState } from "react";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import bgVideo from "../assets/contact_form.mp4";
import sinlogo from "../assets/sinlogo.png";
import { FaWhatsapp } from "react-icons/fa";
import emailjs from "@emailjs/browser";
import { useNavigate } from "react-router-dom"; // if you use react-router

const CAPI_URL = "https://meta-capi-worker.jaikiran1027.workers.dev/";

const getCookie = (n) =>
  document.cookie.split("; ").find((r) => r.startsWith(n + "="))?.split("=")[1];

const ContactSection = () => {
  const [form, setForm] = useState({
  name: "",
  service: "",
  email: "",
  contact: "",
  message: "",
});
  const [sent, setSent] = useState(false);

  const handle = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async (e) => {
  e.preventDefault();
  try {
    await emailjs.send(
      "service_gen1w3d", "template_se2e3iq",
      { name: form.name, service: form.service, email: form.email,
        contact: form.contact, message: form.message },
      "EYMetblRh_0AX9aVG"
    );

    // --- tracking runs ONLY after EmailJS succeeds ---
    const eventId = crypto.randomUUID();

    // 1. GTM / GA4
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "generate_lead",
      event_id: eventId,
      form_name: "contact_form",
      service: form.service || undefined,
    });

    // 2. Browser Pixel (eventID enables dedup)
    if (window.fbq) window.fbq("track", "Lead", {}, { eventID: eventId });

    // 3. Server event (keepalive so it survives navigation)
    fetch(CAPI_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      keepalive: true,
      body: JSON.stringify({
        eventId,
        name: form.name, email: form.email, phone: form.contact,
        fbp: getCookie("_fbp"), fbc: getCookie("_fbc"),
        sourceUrl: window.location.href,
        // testCode: "TEST12345", // temporary, from Events Manager → Test events
      }),
    }).catch(() => {});

    setForm({ name: "", service: "", email: "", contact: "", message: "" });
    navigate("/thankyou");
  } catch (error) {
    console.error("EmailJS Error:", error);
    alert("Failed to send message.");
  }
};

  const inputStyle = {
    width: "100%",
    background: "transparent",
    border: "none",
    borderBottom: "1px solid rgba(255,255,255,0.15)",
    padding: "14px 0",
    color: "#fff",
    fontSize: "14px",
    fontFamily: "'Poppins', sans-serif",
    outline: "none",
    transition: "border-color .2s",
  };

  return (
    <>
      <style>{`
        .contact-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 80px;
          align-items: center;
          flex: 0;
          margin:auto 0;
        }
        .contact-content {
          padding: 48px 40px;
        }
        .contact-logo {
          margin-bottom: 60px;
        }
        .contact-pills {
          flex-wrap: nowrap;
        }

        @media (max-width: 767px) {
          .contact-grid {
            grid-template-columns: 1fr;
            gap: 40px;
          }
          .contact-content {
            padding: 36px 20px 48px;
          }
          .contact-logo {
            margin-bottom: 32px;
          }
          .contact-pills {
            flex-wrap: wrap !important;
          }
          .contact-pill-phone,
          .contact-pill-ig {
            // flex: 1 1 auto;
            justify-content: flex-start;
          }
        }
      `}</style>

      <section
        id="contact"
        style={{
          position: "relative",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          fontFamily: "'Poppins', sans-serif",
          overflow: "hidden",
        }}
      >
        {/* === VIDEO BACKGROUND === */}
        <video
          autoPlay
          loop
          muted
          playsInline
          style={{
            position: "absolute",
            top: 0, left: 0,
            width: "100%",
             height: "100%",
            objectFit: "cover",
            zIndex: 0,
          }}
        >
          <source src={bgVideo} type="video/mp4" />
        </video>

        {/* Dark overlay */}
        <div style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 1 }} />

        {/* Content */}
        <div
          className="contact-content"
          style={{
            position: "relative",
            zIndex: 2,
            flex: 1,
            display: "flex",
            flexDirection: "column",
            maxWidth: 1100,
            margin: "0 auto",
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          {/* Logo */}

          
          {/* Two-column grid → single col on mobile */}
          <div className="contact-grid">

            {/* ── LEFT COLUMN ── */}
          
              <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%" }}>
            <div className="contact-logo" style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <img src={sinlogo} alt="Sintex Logo" width="200"  />
            </div>

            <div>
              <p style={{
                fontSize: 20, fontWeight: 600,
                lineHeight: "28px", 
                letterSpacing: "0.2em", textTransform: "uppercase",
                background: "linear-gradient(135deg, #129ADC, #B55DD0, #E154AA, #F45A39)",
                WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
                backgroundClip: "text", display: "inline-block", marginBottom: 16,
              }}>
                Contact Us
              </p>

              <h2 style={{
                fontFamily: "'Space Grotesk', sans-serif",
                fontSize: "36px",
                fontWeight: 700, color: "#fff",
                lineHeight: "40px", marginBottom: 40,
              }}>
                Let's Fix That<br />
                <span style={{ fontWeight: 900 }}>AVERAGE</span> Problem
              </h2>
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                {/* Email */}
                <a
                  href="mailto:hello@sintx.in"
                  style={{
                    display: "inline-flex", alignItems: "center", gap: 10,
                    background: "rgba(255,255,255,0.08)",
                    border: "1px solid rgba(255,255,255,0.12)",
                    borderRadius: 100, padding: "10px 20px",
                    color: "#fff", fontSize: 13, textDecoration: "none",
                    width: "fit-content", backdropFilter: "blur(8px)",
                    transition: "background .2s",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.15)")}
                  onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.08)")}
                >
                  <span style={{
                    width: 28, height: 28, borderRadius: "50%",
                    background: "#226FA9", display: "flex",
                    alignItems: "center", justifyContent: "center", flexShrink: 0,
                  }}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                      <polyline points="22,6 12,13 2,6" />
                    </svg>
                  </span>
                  hello@sintx.in
                </a>

                {/* Phone + Instagram row */}
                <div className="contact-pills" style={{ display: "flex", gap: 12 }}>
                  <a
                    href="tel:9491105026"
                    className="contact-pill-phone"
                    style={{
                      display: "inline-flex", alignItems: "center", gap: 10,
                      background: "rgba(255,255,255,0.08)",
                      border: "1px solid rgba(255,255,255,0.12)",
                      borderRadius: 100, padding: "10px 20px",
                      color: "#fff", fontSize: 13, textDecoration: "none",
                      backdropFilter: "blur(8px)", transition: "background .2s",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.15)")}
                    onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.08)")}
                  >
                    <span style={{
                      width: 28, height: 28, borderRadius: "50%",
                      background: "#25D366", display: "flex",
                      alignItems: "center", justifyContent: "center", flexShrink: 0,
                    }}>
                      {/* <svg width="13" height="13" viewBox="0 0 24 24" fill="#fff">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
                        <path d="M11.99 0C5.373 0 0 5.373 0 11.99c0 2.122.558 4.112 1.528 5.837L.057 23.99l6.304-1.654A11.934 11.934 0 0011.99 24C18.616 24 24 18.617 24 11.99 24 5.373 18.617 0 11.99 0z" fill="#fff" />
                      </svg> */}
                    <Phone size={14} color="#fff" />
                    </span>
                    9491105026
                  </a>

                  <a
                    href="https://instagram.com/sintxverse"
                    target="_blank"
                    rel="noreferrer"
                    className="contact-pill-ig"
                    style={{
                      display: "inline-flex", alignItems: "center", gap: 10,
                      background: "rgba(255,255,255,0.08)",
                      border: "1px solid rgba(255,255,255,0.12)",
                      borderRadius: 100, padding: "10px 20px",
                      color: "#fff", fontSize: 13, textDecoration: "none",
                      backdropFilter: "blur(8px)", transition: "background .2s",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.15)")}
                    onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.08)")}
                  >
                    <span style={{
                      width: 28, height: 28, borderRadius: "50%",
                      background: "linear-gradient(135deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888)",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      fontSize: 13, flexShrink: 0,
                    }}>
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2">
                        <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                        <circle cx="12" cy="12" r="4" />
                        <circle cx="17.5" cy="6.5" r="1" fill="#fff" stroke="none" />
                      </svg>
                    </span>
                    @sintxverse
                  </a>
                </div>
              </div>
              </div>

            {/* ── RIGHT COLUMN: Glass Form ── */}
            <motion.div
              initial={{ opacity: 0, x: 24 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: 0.15 }}
            >
              <div style={{
                background: "rgba(255,255,255,0.05)",
                backdropFilter: "blur(20px)",
                WebkitBackdropFilter: "blur(20px)",
                border: "1px solid rgba(255,255,255,0.1)",
                borderRadius: 24,
                padding: "clamp(28px, 5vw, 40px) clamp(20px, 4vw, 36px)",
              }}>
                <h3 style={{
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontSize: "clamp(1.1rem, 3vw, 1.4rem)",
                  fontWeight: 700, color: "#fff", marginBottom: 6,
                }}>
                  Tell us about your project
                </h3>
                <p style={{ fontSize: 13, color: "rgba(255,255,255,0.45)", marginBottom: 32 }}>
                  we'll get back within 24 hours
                </p>

                <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                  {[
                    { name: "name", placeholder: "Your Name", required: true },
                    { name: "service", placeholder: "Service Needed" },
                    { name: "email", placeholder: "Email Address", required: true },
                    { name: "contact", placeholder: "Phone Number", required: true },
                  ].map((field) => (
                    <input
                      key={field.name}
                      name={field.name}
                      placeholder={field.placeholder}
                      value={form[field.name]}
                      onChange={handle}
                      required={field.required}
                      style={inputStyle}
                      onFocus={(e) => (e.target.style.borderBottomColor = "rgba(255,255,255,0.5)")}
                      onBlur={(e) => (e.target.style.borderBottomColor = "rgba(255,255,255,0.15)")}
                    />
                  ))}

                  <textarea
                    name="message"
                    placeholder="Message"
                    value={form.message}
                    onChange={handle}
                    rows={3}
                    style={{ ...inputStyle, resize: "none", paddingTop: 14 }}
                    onFocus={(e) => (e.target.style.borderBottomColor = "rgba(255,255,255,0.5)")}
                    onBlur={(e) => (e.target.style.borderBottomColor = "rgba(255,255,255,0.15)")}
                  />

                  <motion.button
                    whileHover={{ scale: 1.03 }}
                    whileTap={{ scale: 0.97 }}
                    type="submit"
                    style={{
                      marginTop: 16,
                      padding: "13px 0",
                      borderRadius: 100,
                      border: "none",
                      fontFamily: "'Poppins', sans-serif",
                      fontSize: 14, fontWeight: 700,
                      cursor: "pointer",
                      background: sent
                        ? "linear-gradient(135deg, #129ADC, #E154AA)"
                        : "#fff",
                      color: sent ? "#fff" : "transparent",
                      backgroundClip: sent ? "border-box" : "text",
                      WebkitBackgroundClip: sent ? "border-box" : "text",
                      WebkitTextFillColor: sent ? "#fff" : "transparent",
                      backgroundImage: sent
                        ? "none"
                        : "linear-gradient(135deg, #129ADC, #B55DD0, #E154AA, #F45A39)",
                      transition: "all .3s",
                    }}
                  >
                    {sent ? "✓ Sent!" : "Start Your Project"}
                  </motion.button>

                  <a
                    href="whatsapp://send?phone=+91 9491105026&text=Hello%20Sintx!%20I%20would%20like%20to%20request%20a%20quote."
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8,
                      marginTop: 16,
                      fontSize: 13,
                      color: "rgba(255,255,255,0.5)",
                      textDecoration: "none",
                      transition: "color .2s",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = "#25D366")}
                    onMouseLeave={(e) => (e.currentTarget.style.color = "rgba(255,255,255,0.5)")}
                  >
                    <FaWhatsapp size={18} />
                    <span>Prefer quick chat?</span>
                  </a>
                </form>
              </div>
            </motion.div>

          </div>
        </div>
      </section>
    </>
  );
};

export default ContactSection;